import * as React from 'react';
import {Editor, EditorChangeEvent, EditorTools, EditorUtils} from "@progress/kendo-react-editor";
import '@progress/kendo-theme-default/dist/all.css';
import GridContainer from "../GenericComponents/Grids/GridContainer";
import {createBreadCrumbBasedOnPage} from "../../Utils/HelperFunctions";
import * as actionTypes from "../../store/action";
import {connect} from "react-redux";
import {
    Button,
    ButtonProps,
    Container,
    Dimmer,
    Form,
    Header,
    Icon,
    Loader, Modal,
    TextArea,
    TextAreaProps
} from "semantic-ui-react";
import TracLetterRecordPage from "../TracLetters/TracLetterRecordPage";
import { AccordionSegment } from '../GenericComponents/AccordianSegment';
import TracModal from "../GenericComponents/TracModal";
import LetterApi from "../../services/letter-service";
import {toast} from "react-toastify";
import history from '../../history';

const {Bold, Italic, Underline, Strikethrough, Subscript, Superscript, AlignLeft, AlignCenter, AlignRight, AlignJustify,
    Indent, Outdent, OrderedList, UnorderedList, Undo, Redo, FontSize, FontName, FormatBlock, Link, Unlink, InsertImage,
    ViewHtml, InsertTable, AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter, DeleteRow, DeleteColumn, DeleteTable,
    MergeCells, SplitCell,} = EditorTools;

//This is sample content and will be replaced by the text from the template
const sampleTemplate = `<head> <title></title> <!--[if gte mso 9]> <xml><w:WordDocument><w:View>Normal</w:View><w:Zoom>100</w:Zoom><w:DoNotOptimizeForBrowser/></w:WordDocument></xml> <![endif]--> <style> @page Section1 { size: 8.5in 11.0in; mso-footer: f1; mso-header: h1; padding: 24.0pt 24.0pt 24.0pt 24.0pt; margin: 0.75in 1.00in 0.75in 1.00in; mso-header-margin: 0.5in; /*top padding*/ mso-footer-margin: 0.5in; /*bottom padding*/ mso-paper-source: 0; mso-title-page: yes; mso-page-numbers: 0; } div.Section1 { page: Section1; } {PDF_HEADER_AND_FOOTER_INFO} p.MsoFooter, li.MsoFooter, div.MsoFooter { [FOOTER_MARGIN] margin-bottom: .0001pt; mso-pagination: widow-orphan; tab-stops: center 3.0in right 6.0in; font-size: 12.0pt; font-family: 'Times New Roman'; } p.MsoHeader, li.MsoHeader, div.MsoHeader { margin-left: -.5in; margin-bottom: 12pt; mso-pagination: widow-orphan; tab-stops: center 3.0in right 6.0in; font-size: 12.0pt; font-family: 'Times New Roman'; } </style></head><body lang="EN-US" style='tab-interval: .5in'><div class="Section1"> {WORD_OR_PDF_HEADER} <!--Document Body--> <table cellpadding="0" style="width: 100%; border-collapse: collapse;"> <tbody> <tr> <td align="center"> <span style="font-weight: bold; font-size: 14pt;">SPP <br /> Notification to Construct with Conditions</span> </td> </tr> <tr> <td> </td> </tr> <tr> <td> <table width="100%"> <tbody> <tr> <td style="text-align: left;"> {DateLetterSent} </td> </tr> </tbody> </table> </td> </tr> <tr> <td> <br /> <br /> {Greeting} {FirstName} {LastName}<br /> {Company}<br /> {Address1}<br /> {City}, {State} {Zip}<br /> <br /> RE: {MODIFICATION_OR_WITHDRAWAL_OF}Notification to Construct for Transmission Service Request resulting from Aggregate Transmission Service Study {Study}<br /> <br /> Dear {Greeting} {LastName},<br /> <br /> Pursuant to Section 3.3 of the Southwest Power Pool, Inc. ("SPP") Membership Agreement and Attachments O and Y of the SPP Open Access Transmission Tariff ("OATT"), SPP provides this Notification to Construct ("NTC") directing {Company} ("{TRANS_OWNER_CODE}"), as the Designated Transmission Owner, to construct the Network Upgrades. This NTC is conditioned upon EDE not ordering materials or beginning construction until:<br /> <br /> (1) the DTO submits a refined NTC-C Project Estimate ("CPE") to SPP that has a variance bandwidth of -20% to +20% that does not exceed the Study Estimate variance bandwidth of -30% to +30% as provided for in SPP's Business Practices; or<br /> <br /> (2) the SPP Board of Directors considers SPP's re-evaluation of a project that has a refined CPE from the DTO that exceeds the Study Estimate variance bandwidth of -30% to +30% as provided for in SPP's Business Practices.<br /> <br /> {BOARD_OF_DIRECTORS_PARAGRAPH} </tr> {NEW_NETWORK_UPGRADES_PARAGRAPH} {COMMITMENT_TO_CONSTRUCT_PARAGRAPH} {CPE_PARAGRAPH} {REMOVAL_OF_CONDITIONS_PARAGRAPH} {MITIGATION_PLAN_PARAGRAPH} {NOTIFICATION_OF_COMMERCIAL_OPERATION_PARAGRAPH} {NOTIFICATION_OF_PROGRESS_PARAGRAPH} {WITHDRAWAL_PARAGRAPH} {CLOSING_PARAGRAPH} {CC_SECTION} </tbody> </table> {WORD_FOOTER}</div></body>`;

interface NtcLetterEditProps {
    setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => void;
    location:any;
}

interface NtcLetterEditState {
    templateContent: string;
    ntcLetterEditPageOpen: boolean;
    gridVisible: boolean;
    tracRecord: any;
    tracRecordIndex: number;
    letterType: string;
    modalOpen: boolean;
    editor: any;
    savingLetter: boolean;
    loadingLetter: boolean;
    previewLetterContent: string;
    canRevertLetter: boolean;
}

class NtcLetterEdit extends React.Component<NtcLetterEditProps,NtcLetterEditState> {
    private client: LetterApi;

    constructor(props: NtcLetterEditProps) {
        super(props);
        this.state = {
            templateContent: ``,
            ntcLetterEditPageOpen: true,
            gridVisible: true,
            tracRecord: this.props.location.state.data,
            tracRecordIndex: -1,
            letterType: 'ntc',
            modalOpen: false,
            editor: React.createRef<Editor>(),
            savingLetter: false,
            loadingLetter: false,
            previewLetterContent: '',
            canRevertLetter: false
        };
        this.client = new LetterApi();
    }


    componentDidMount(): void {
        this.getEditLetterData();
        this.props.setBreadCrumbPath(createBreadCrumbBasedOnPage(window.location.pathname.split('/').filter(x => x)));
    }

    getEditLetterData = (revertLetter?:boolean) =>{
        if(revertLetter === undefined) {
            revertLetter = false;
        }
        this.setState({loadingLetter:true, templateContent: ''})
        this.client.getLetterEdit(this.state.letterType, this.state.tracRecord.ntcId, revertLetter)
            .then((response: EditLetterDto) => {
                if(response.letterSuccess) {
                    this.setState({templateContent: response.htmlLetter, canRevertLetter: response.canRevert, loadingLetter: false});
                }
                else {
                    if(revertLetter) {
                        toast.error('Error occured reverting to original letter version');
                    }
                    else {
                        toast.error('Error occured getting Edit Letter');
                    }
                    this.setState({loadingLetter: false});
                }
            })
            .catch((error:any) => {
                this.setState({loadingLetter: false});
            });
    }

    viewRecord = (event: React.MouseEvent<HTMLButtonElement>, data:ButtonProps) => {
        this.setState({ntcLetterEditPageOpen:true, gridVisible: true, tracRecord:data.row, tracRecordIndex: data.rowIndex});
    };

    saveRecord = () =>{
        this.setState({savingLetter: true})
        let letterRequest: LetterRequest ={
            letterType: this.state.letterType,
            letterId: this.state.tracRecord.ntcId,
            letterContent: this.state.templateContent//EditorUtils.getHtml(this.state.editor.current.view.state)
        }
        this.client.saveLetter(letterRequest).then((resp:string) =>{
            toast.success('Letter saved successfully.')
            this.setState({savingLetter:false})
        })
    }

    getViewButton = () => {
        return {
            iconName: 'eye',
            iconColor: 'blue',
            onClick: this.viewRecord,
            popupContent: 'View/Approve NTC'
        }
    };

    getExtraUtilityColumns = () => {
        return [
            //this.getViewButton()
        ];
    };

    setNtcGridOpen = (gridVisible:boolean, tracLetterRecordPageOpen:boolean) => {
        this.setState({gridVisible, ntcLetterEditPageOpen: tracLetterRecordPageOpen});
    };

    setLetterType = (letterType:string) => {
        this.setState({letterType});
    };

    ModalHeader = () => {
        let iconName:any, header;
        header = 'Letter Preview';

        return (
            <Header as='h3'>
                {header}
            </Header>
        )
    };

    ModalContent = () => {
        return (
            <div>
                <div id={'previewLetter'}
                     dangerouslySetInnerHTML={{
                         __html: this.state.previewLetterContent
                     }}>
                </div>
            </div>
        )
    };

    ModalActions = () => {
        return (
            <div>
                <Button content={'Close'} color={'red'} onClick={this.ModalClose}/>
            </div>
        )
    };

    ModalClose = () => {
        this.setState({modalOpen: false});
    };

    backToLetterPage = (event: React.MouseEvent<HTMLButtonElement>, data:ButtonProps) => {
        history.push({pathname: `/NTC/${this.state.tracRecord.ntcId}`, state: {from: 'ntcLetterEdit'}});
    }

    discardChanges = (event: React.MouseEvent<HTMLButtonElement>, data:ButtonProps) => {
        /*if (this.state.editor.current) {
            const view = this.state.editor.current.view;

            if (view) {
                this.getEditLetterData();
            }
        }*/
        this.getEditLetterData();
    }

    editorChange = (event: EditorChangeEvent) => {
        this.setState({ templateContent: event.html });
    }

    previewLetter = (event: React.MouseEvent<HTMLButtonElement>, data:ButtonProps) => {
        this.setState({loadingLetter: true});
        let letterRequest: LetterRequest ={
            letterType: this.state.letterType,
            letterId: this.state.tracRecord.ntcId,
            letterContent: this.state.templateContent//EditorUtils.getHtml(this.state.editor.current.view.state)
        }
        this.client.previewLetter(letterRequest).then((resp:string) =>{
            this.setState({modalOpen: true, previewLetterContent: resp, loadingLetter: false})
        });
    };

    revertLetter = (event: React.MouseEvent<HTMLButtonElement>, data:ButtonProps) => {
        let revertLetter = true;
        this.getEditLetterData(revertLetter);
    }

    render() {
        return (
            <React.Fragment>
                <Dimmer active={this.state.savingLetter} inverted={true}>
                    <Loader>Saving</Loader>
                </Dimmer>
                <Dimmer active={this.state.loadingLetter} inverted={true}>
                    <Loader>Loading</Loader>
                </Dimmer>
                <TracModal header={this.ModalHeader()} content={this.ModalContent} actions={this.ModalActions}
                           open={this.state.modalOpen} closeOnDimmerClick={true} closeIcon={true}
                           onClose={this.ModalClose}
                />
                <Button icon={true} labelPosition='left' onClick={this.backToLetterPage}>
                    <Icon name={'arrow left'}/>
                    Back to Letter
                </Button>
                <Button icon={true} labelPosition='left' onClick={this.previewLetter}>
                    <Icon name={'eye'}/>
                    Preview Letter
                </Button>
                <Button icon={true} labelPosition='left' onClick={this.saveRecord}>
                    <Icon name={'save'}/>
                    Save Letter
                </Button>
                {this.state.canRevertLetter &&
                    <Button icon={true} labelPosition='left' onClick={this.revertLetter}>
                        <Icon name={'undo'}/>
                        Revert Letter
                    </Button>
                }
                <Button icon={true} labelPosition='left' onClick={this.discardChanges}>
                    <Icon name={'cancel'}/>
                    Discard Changes
                </Button>
                <div className='ntcLetterEditor'>
                    {this.state.templateContent &&
                        <Editor tools={[[Bold, Italic, Underline, Strikethrough], [Subscript, Superscript],
                            [AlignLeft, AlignCenter, AlignRight, AlignJustify], [Indent, Outdent],
                            [OrderedList, UnorderedList], FontSize, FontName, FormatBlock, [Undo, Redo],
                            [Link, Unlink, InsertImage, ViewHtml], [InsertTable],
                            [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
                            [DeleteRow, DeleteColumn, DeleteTable], [MergeCells, SplitCell]]}
                                contentStyle={{
                                    height: 700
                                }}
                                defaultEditMode={'div'}
                                preserveWhitespace={false}
                                value={this.state.templateContent}
                                onChange={this.editorChange}
                        />
                    }
                </div>
                <Container fluid={true}>
                    <AccordionSegment segmentHeader={'Letter Comments'}>
                        <GridContainer
                            getGridDataUrl={'/api/auth/getLetterComments/' + this.state.tracRecord.approvalTrackerId.id}
                            gridTitle={'View Letter Comments'}
                            gridId={'letterCommentGrid'}
                        />
                    </AccordionSegment>
                    <AccordionSegment segmentHeader={'NTC Info'} >
                        <GridContainer
                            getGridDataUrl={'/api/auth/getNtcEditGrid/' + this.state.tracRecord.ntcId}
                            //getGridDataUrl={'/api/auth/viewGridData/ntc'}
                            //addRecordUrl={'/api/auth/saveGridRecord/ntc'}
                            editRecordUrl={'/api/auth/editGridRecord/ntc'}
                            //deleteRecordUrl={'/api/auth/removeGridRecord/ntc'}
                            //gridPaginated={true}
                            formEditing={true}
                            showUtilityColumns={true}
                            exportLink={'viewGridData/ntc'}
                            gridTitle={'View NTCs'}
                            gridId={'ntcGrid'}
                            extraUtilityColumns={this.getExtraUtilityColumns()}
                            typeForSuperClass={'ntc'}
                            gridVisible={this.state.gridVisible}
                            complexAddForm={'/createNtc'}
                        />
                    </AccordionSegment>
                    <AccordionSegment segmentHeader={'NTC Upgrade Info'} >
                        <GridContainer
                            getGridDataUrl={'/api/auth/getNtcUpgradeInfoForNtcGrid/' + this.state.tracRecord.ntcId}
                            addRecordUrl={'/api/auth/saveGridRecord/ntcUpgradeInfo'}
                            editRecordUrl={'/api/auth/editGridRecord/ntcUpgradeInfo'}
                            //deleteRecordUrl={'/api/auth/removeGridRecord/ntcUpgradeInfo'}
                            //gridPaginated={true}
                            formEditing={true}
                            showUtilityColumns={true}
                            exportLink={'viewGridData/ntcUpgradeInfo'}
                            gridTitle={'View NTC Upgrade Info'}
                            gridId={'ntcUpgradeInfoGrid'}
                            typeForSuperClass={'ntcUpgradeInfo'}
                        />
                     </AccordionSegment>
                    <AccordionSegment segmentHeader={'Upgrade Info'} >
                        <GridContainer
                            getGridDataUrl={'/api/auth/getUpgradesForNtcIdGrid/' + this.state.tracRecord.ntcId}
                            editRecordUrl={'/api/auth/editGridRecord/upgrade'}
                            formEditing={true}
                            showUtilityColumns={true}
                            //exportLink={'viewGridData/upgradeBus'}
                            gridTitle={'View Upgrades for NTC'}
                            gridId={'upgradeGrid'}
                            typeForSuperClass={'upgrade'}
                        />
                    </AccordionSegment>
                    <AccordionSegment segmentHeader={'Upgrade Cost Info'} >
                        <GridContainer
                            getGridDataUrl={'/api/auth/getUpgradeCostInfoListForNtcIdGrid/' + this.state.tracRecord.ntcId}
                            //addRecordUrl={'/api/auth/saveGridRecord/upgradeCostInfo'}
                            editRecordUrl={'/api/auth/editGridRecord/upgradeCostInfo'}
                            //deleteRecordUrl={'/api/auth/removeGridRecord/upgradeCostInfo'}
                            //gridPaginated={true}
                            formEditing={true}
                            showUtilityColumns={true}
                            exportLink={'viewGridData/upgradeCostInfo'}
                            gridTitle={'View Upgrade Cost Info'}
                            gridId={'upgradeCostInfoGrid'}
                            typeForSuperClass={'upgradeCostInfo'}
                        />
                    </AccordionSegment>
                    <AccordionSegment segmentHeader={'Project Info'} >
                        <GridContainer
                            getGridDataUrl={'/api/auth/getProjectsInNtcLetterGrid/' + this.state.tracRecord.ntcId}
                            //addRecordUrl={'/api/auth/saveGridRecord/project'}
                            editRecordUrl={'/api/auth/editGridRecord/project'}
                            //deleteRecordUrl={'/api/auth/removeGridRecord/project'}
                            //gridPaginated={true}
                            formEditing={true}
                            showUtilityColumns={true}
                            exportLink={'viewGridData/project'}
                            gridTitle={'View Projects'}
                            gridId={'projectGrid'}
                            freezeColumn
                            bulkUpload={true}
                            typeForSuperClass={'project'}
                        />
                    </AccordionSegment>
                    <AccordionSegment segmentHeader={'NTC Contact Info'} >
                        <GridContainer
                            getGridDataUrl={'/api/auth/getNtcContactsByTransmissionOwnerCode/' + this.state.tracRecord.transmissionOwnerCode}
                            editRecordUrl={'/api/auth/editGridRecord/ntcContact'}
                            formEditing={true}
                            showUtilityColumns={true}
                            gridTitle={'View NTC Contacts'}
                            gridId={'ntcContactGrid'}
                            typeForSuperClass={'ntcContact'}
                        />
                    </AccordionSegment>
                </Container>

            </React.Fragment>
        );
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => dispatch(
            {type: actionTypes.SET_BREADCRUMB_PATH, payload: breadCrumbPath})
    }
};

export default connect(null, mapDispatchToProps)(NtcLetterEdit);